/**
 * CLE-2811 (2026-09-28) — Ani: "3rd step (Rates and Fee schedules) should be removed now so it doesn't have
 * continue. It should be Save Draft."
 *
 * The rates stage comes back in its own ticket, so it is HIDDEN here, not removed: every component,
 * helper, mutation, copy string and test for it stays, and every entry point into it — the locked
 * "Rates & fee schedules" rail row and both "Continue to rates" buttons — reads this one constant
 * (`ratesStageEntries` in `wizard/steps.ts`). With it off, a facts run's last button is "Save draft".
 * Flipping it to true restores today's behaviour exactly.
 *
 * A run already at the full stage renders as it always has, whatever this says.
 *
 * The run page takes it as a prop (`ContractModelDraftDetail`'s `ratesStageEnabled`, defaulting to this),
 * so a test can render either side.
 *
 * The API still serves "Continue to rates" (`POST /contract-model-drafts/runs/:id/continue`) while this is
 * off; only the page stops offering it.
 */
export const RATES_STAGE_ENABLED = false;
